module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("To all the doctoral students past and present"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n  who have studied under the remarkable scholars who have"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n  taught in Durham’s theology department"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n  over the last century.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116713c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedi.vue
// module id = 66
// module chunks = 0